"use client"

import { useStorePrivilege } from "@/app/store/slices/collection/privilege/hook"
import { useStoreSession } from "@/app/store/slices/session/hook"
import { Operator } from "@/savaradio/common"
import { usePathname, useRouter } from "next/navigation"
import { useEffect } from "react"

export function ContentNeedSession({ redirect, children, pass }: { redirect?: boolean, children: React.ReactNode, pass?: boolean }) {
  const { session, retrieve, self } = useStoreSession()
  const { privileges_target } = useStorePrivilege(true, true)
  const router = useRouter()
  const pathname = usePathname()

  useEffect(() => {
    if (!session) {
      retrieve()
        .then(res => {
          if (!res && redirect) {
            router.push("/auth/signin")
          }
        })
        .catch(() => redirect && router.push("/auth/signin"))
    }
  }, [])

  useEffect(() => {
    if (session && self) {
      if (session.role === "operator" && !(self as Operator).validated) {
        router.push("/auth/attente")
      }
    }
  }, [session, self])

  useEffect(() => {
    if (session) {
      if (pathname.startsWith("/manage") && session.role === "operator" && self) {
        if (privileges_target.length === 0) router.push("/home")
        else {
          const rules: Record<string, number[]> = {
            "/manage/client": [3, 4],
            "/manage/operator": [2, 4],
            "/manage/actuality": [6, 4],
            "/manage/advertising": [7, 4],
            "/planification/advertise": [5, 4],
          };

          if (rules[pathname]) {
            const allowedTypes = rules[pathname];

            const hasPrivilege = privileges_target.some(
              item => allowedTypes.includes(Number(item.type)) && !!item.validated
            );
            
            if (!hasPrivilege) router.push("/home")

          }
        }
      }
    }
  }, [pathname, session, self, privileges_target])

  if (pass) return <>{children}</>
  if (!session) return null
  return <>{children}</>
}